
<template>
  <el-dialog title="批量修改佣金" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap">
      <el-form ref="form" :model="formdata" label-width="50px">
        <el-form-item>
          <el-radio-group v-model="formdata.comm_set">
            <el-radio
              v-for="(item,index) in commset"
              :label="item.value"
              :key="index"
            >{{item.label}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          分销佣金比例(外部人员)
          <span v-if="formdata.comm_set===0">{{formdata.outside}}</span>
          <el-input v-else v-model="formdata.comm_outside" type="text" class="w80"></el-input>%
        </el-form-item>
        <el-form-item>
          销售佣金比例(企业员工)：
          <span v-if="formdata.comm_set===0">{{formdata.inside}}</span>
          <el-input v-else type="text" v-model="formdata.comm_inside" class="w80"></el-input>%
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="save('form')">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { commset } from "@/util/util.js";
import api from "@/api.js";
export default {
  name: "chooseClassifyDialog",
  props: ["visible", "ids"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      formdata: {
        comm_set: 0,
        comm_outside: "",
        comm_inside: "",
        outside: "",
        inside: ""
      },
      commset: commset
    };
  },
  created() {
    this.querydistribution();
  },
  methods: {
    // 获取分销规则
    querydistribution() {
      let params = {};
      this.axios
        .post(api.goods_distribution, params)
        .then(response => {
          if (response.data.code == 0) {
            this.formdata.outside = response.data.info.comm_outside;
            this.formdata.inside = response.data.info.comm_inside;
          } else {
          }
        })
        .catch(() => {});
    },
    // 保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submitsave();
        } else {
          return false;
        }
      });
    },
    // 提交保存 批量添加到分类
    submitsave() {
      let params = {
        id: this.ids,
        comm_set: this.formdata.comm_set,
        comm_outside: this.formdata.comm_outside,
        comm_inside: this.formdata.comm_inside
      };
      this.axios
        .post(api.goods_edit_commission, params)
        .then(response => {
          if (response.data.code == 0) {
            this.$emit("success");
            this.$message({
              message: "批量修改佣金成功",
            });
            this.dialogVisible = false;
          } else {
          }
        })
        .catch(() => {});
    }
  }
};
</script>

